import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.development';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UsuarioService {
  private userApiUrl = `${environment.apiUrl}/users`;
  constructor(private http: HttpClient) {}

  // ============================================
  // ALTA DE ROLES MÉDICOS Y ENFERMEROS
  //  ===========================================

  crearUsuario(usuario: any): Observable<any> {
    return this.http.post<any>(this.userApiUrl, usuario);
  }

  obtenerUsuarios(): Observable<any[]> {
    return this.http.get<any[]>(this.userApiUrl);
  }

  obtenerUsuario(userId: string): Observable<any> {
    return this.http.get<any>(`${this.userApiUrl}/${userId}`);
  }

  actualizarUsuarioNombre(usuario: any): Observable<any> {
    return this.http.patch<any>(`${this.userApiUrl}/me`, usuario);
  }

  actualizarUsuarioPassword(usuario: any): Observable<any> {
    return this.http.patch<any>(`${this.userApiUrl}/me/password`, usuario);
  }

  actualizarUsuarioRol(usuario: any, userId: string): Observable<any> {
    return this.http.patch<any>(`${this.userApiUrl}/${userId}/role`, usuario);
  }

  actualizarUsuario(userId: string, datos: any): Observable<any> {
    return this.http.patch<any>(`${this.userApiUrl}/${userId}`, datos);
  }

  eliminarUsuario(userId: string): Observable<any> {
    return this.http.delete<any>(`${this.userApiUrl}/${userId}`);
  }
}
